import {AuthRoute} from '@common/auth/guards/auth-route';
import {ActiveWorkspaceProvider} from '@common/workspace/active-workspace-id-context';
import {RouteObject} from 'react-router';

export const bucketRoutes: RouteObject[] = [
  {
    path: 'buckets',
    element: (
      <ActiveWorkspaceProvider>
        <AuthRoute />
      </ActiveWorkspaceProvider>
    ),
    children: [
      {
        lazy: () => import('@app/buckets/bucket-layout'),
        children: [
          {index: true, lazy: () => import('@app/buckets/bucket-list-page')},
          {path: ':slug', lazy: () => import('@app/buckets/bucket-detail-page')},
        ],
      },
    ],
  },
];
